import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import Utilisateur from 'components/Shared/Utilisateur';
import UtilisateurSearch from 'components/Shared/UtilisateurSearch';
import Groupe from 'components/Shared/Groupe';
import GroupeSecuriteSelect from './GroupeSecuriteSelect';
import TransferList from 'components/Shared/TranfertList';

import { green } from '@mui/material/colors';

const styles = theme => ({
    formControl: {
        width: '100%'
    },
    buttonControl: {
        margin: '8px 0px 8px 16px'
    },

    buttonControlGroupesSecurite: {
        margin: '8px 16px 8px 16px'
    },

    chip: {
        margin: '8px 8px 8px 0px'
    },
    listElement: {
        margin: 10,
        padding: '4px 8px 4px 8px'
    },
    root: {
        margin: 0,
        padding: 0
    },

    bold: {
        fontWeight: theme.typography.fontWeightMedium
    },

    container: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column'
    },

    containerPilotes: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row'
    },

    containerGroupesSecurite: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        padding: 8
    },

    containerDrop: {
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        minHeight: '100px'
    },

    containerLeft: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'column',
        marginRight: theme.spacing(1)
    },


    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse'
    },

    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(3)
    },

    table: {
        minWidth: 700
    },

    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },


    guTransit: {
        color: green[500]
    },

    guMirror: {
        color: green[500]
    }
});

class AdministrationGroupe extends React.Component {


    handleDrop = (ids, type) => {

        switch (type) {
            case "action": {
                this.props.onDrop(ids);
                break;
            }
            case "motifResolution": {
                this.props.onDropMotifResolution(ids);
                break;
            }
            case "causePrincipale": {
                this.props.onDropCausePrincipale(ids);
                break;
            }
            default: {
                break;
            }
        }

    };

    handleClickDeletePilote = (event, id) => {
        this.props.onClickDeletePilote(event, id);
    };

    handleClickDeleteGroupeSecurite = (event, id) => {
        this.props.onClickDeleteGroupeSecurite(event, id);
    };

    render() {
        let { classes,
            groupesSecurite,
            groupeSecuriteId,
            selectedGroupe,
            onChange, onClickSave, onChangeUtilisateur, onChangeGroupeSecurite,
            onClickAddPilote, addPiloteEnable, onClickAddToAdmin, onClickAddToMember,
            isPatching,
            sauvegardable,
            actionsNonGeneriques,
            motifsResolutionDisponibles,
            causesPrincipalesDisponibles
        } = this.props;

        return (
            <React.Fragment>

                {selectedGroupe && (
                    <div className={classes.root}>

                        <Helmet>
                            <title>{`Groupe : ${selectedGroupe.code}`}</title>
                        </Helmet>

                        <Typography gutterBottom variant="h5">
                            Édition du groupe de traitement : {selectedGroupe.code}
                        </Typography>

                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Paramètres
                            </Typography>

                            <TextField className={classes.formControl}
                                id="libelle"
                                name="libelle"
                                label="Libellé"
                                placeholder="Libellé"
                                required
                                margin="normal"
                                value={selectedGroupe.libelle}
                                onChange={onChange}
                            />

                            <TextField className={classes.formControl}
                                id="initiales"
                                name="initiales"
                                label="Initiales"
                                placeholder="Initiales"
                                required
                                margin="normal"
                                value={selectedGroupe.initiales}
                                onChange={onChange}
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="actif"
                                        name="actif"
                                        checked={selectedGroupe.actif}
                                        onChange={onChange}
                                        value="Actif"
                                        color="secondary"
                                    />
                                }
                                label="Actif : "
                                labelPlacement="start"
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="visible"
                                        name="visible"
                                        checked={selectedGroupe.visible}
                                        onChange={onChange}
                                        value="Visible"
                                        color="secondary"
                                    />
                                }
                                label="Visible : "
                                labelPlacement="start"
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="autoriseCreationReclamationLiee"
                                        name="autoriseCreationReclamationLiee"
                                        checked={selectedGroupe.autoriseCreationReclamationLiee}
                                        onChange={onChange}
                                        value="AutoriseCreationReclamationLiee"
                                        color="secondary"
                                    />
                                }
                                label="Autorise création dossier après-vente lié : "
                                labelPlacement="start"
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="autoriseSAV"
                                        name="autoriseSAV"
                                        checked={selectedGroupe.autoriseSAV}
                                        onChange={onChange}
                                        value="AutoriseSAV"
                                        color="secondary"
                                    />
                                }
                                label="SAV autorisé : "
                                labelPlacement="start"
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="autoriseMemo"
                                        name="autoriseMemo"
                                        checked={selectedGroupe.autoriseMemo}
                                        onChange={onChange}
                                        value="AutoriseMemo"
                                        color="secondary"
                                    />
                                }
                                label="Mémo autorisé : "
                                labelPlacement="start"
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="notifierEmetteurReclamation"
                                        name="notifierEmetteurReclamation"
                                        checked={selectedGroupe.notifierEmetteurReclamation}
                                        onChange={onChange}
                                        value="NotifierEmetteurReclamation"
                                        color="secondary"
                                    />
                                }
                                label="Notifier émetteur dossier après-vente : "
                                labelPlacement="start"
                            />

                            <FormControlLabel
                                control={
                                    <Switch
                                        id="notifierPilote"
                                        name="notifierPilote"
                                        checked={selectedGroupe.notifierPilote}
                                        onChange={onChange}
                                        value="NotifierPilote"
                                        color="secondary"
                                    />
                                }
                                label="Notifier pilote : "
                                labelPlacement="start"
                            />
                        </Paper>

                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Pilotes
                            </Typography>

                            {selectedGroupe.pilotes.map(pilote => {
                                return (
                                    <FormControl key={pilote.id} className={classes.chip}>
                                        <Utilisateur utilisateur={pilote} format="deletablechip" onDelete={event => this.handleClickDeletePilote(event, pilote.id)} />
                                    </FormControl>
                                );
                            })}

                            <div className={classes.containerPilotes}>
                                <FormControl>
                                    <UtilisateurSearch
                                        namespace={"administrationGroupes"}
                                        onChange={onChangeUtilisateur}
                                        isRequired={false}
                                        label={"Rechercher un utilisateur"}
                                        className={classes.formControl}
                                    />
                                </FormControl>


                                <Button onClick={onClickAddPilote} disabled={!addPiloteEnable} variant="contained" color="primary" className={classes.buttonControl}>Ajouter pilote</Button>

                            </div>
                        </Paper>

                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Actions
                            </Typography>

                            {selectedGroupe.actions && actionsNonGeneriques &&
                                <TransferList
                                    listeGauche={selectedGroupe.actions}
                                    listeDroite={actionsNonGeneriques}
                                    onChange={(ids) => this.handleDrop(ids, 'action')}
                                />
                            }
                        </Paper>


                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Motifs de résolution
                            </Typography>

                            {selectedGroupe.motifsResolution && motifsResolutionDisponibles &&
                                <TransferList
                                    listeGauche={selectedGroupe.motifsResolution}
                                    listeDroite={motifsResolutionDisponibles}
                                    onChange={(ids) => this.handleDrop(ids, 'motifResolution')}
                                />
                            }

                        </Paper>


                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Causes principales
                            </Typography>

                            {selectedGroupe.causesPrincipales && causesPrincipalesDisponibles &&
                                <TransferList
                                    listeGauche={selectedGroupe.causesPrincipales}
                                    listeDroite={causesPrincipalesDisponibles}
                                    onChange={(ids) => this.handleDrop(ids, 'causePrincipale')}
                                />
                            }

                        </Paper> 

                        <Paper className={classes.paper}>

                            <Typography gutterBottom variant="h6">
                                Groupes de sécurité
                            </Typography>

                            <Grid container spacing={3} >

                                <Grid item xs={4}>
                                    <Paper className={classes.containerGroupesSecurite}>
                                        <Typography gutterBottom variant="subtitle1">
                                            Administrateur
                                        </Typography>
                                        {selectedGroupe.groupesSecurite.filter(x => x.administrateur).map(groupeSecurite => {
                                            return (
                                                <FormControl className={classes.chip} key={groupeSecurite.id} >
                                                    <Groupe groupe={groupeSecurite} format="deletablechip" onDelete={event => this.handleClickDeleteGroupeSecurite(event, groupeSecurite.id)} />
                                                </FormControl>
                                            );
                                        })}
                                    </Paper>
                                </Grid>

                                <Grid item xs={4}>
                                    <Paper className={classes.containerGroupesSecurite}>
                                        <Typography gutterBottom variant="subtitle1">
                                            Affectés
                                        </Typography>
                                        {selectedGroupe.groupesSecurite.filter(x => !x.administrateur).map(groupeSecurite => {
                                            return (
                                                <FormControl className={classes.chip} key={groupeSecurite.id} >
                                                    <Groupe groupe={groupeSecurite} format="deletablechip" onDelete={event => this.handleClickDeleteGroupeSecurite(event, groupeSecurite.id)} />
                                                </FormControl>
                                            );
                                        })}
                                    </Paper>

                                </Grid>

                                <Grid item xs={4}>
                                    <Paper className={classes.containerGroupesSecurite}>
                                        <Typography gutterBottom variant="subtitle1">
                                            Disponibles
                                        </Typography>
                                        <GroupeSecuriteSelect className={classes.formControl}
                                            disabled={false}
                                            value={groupeSecuriteId}
                                            onChange={onChangeGroupeSecurite}
                                            all={false}
                                            isRequired={false}
                                            groupes={groupesSecurite}
                                        />

                                        <Button className={classes.buttonControlGroupesSecurite} onClick={onClickAddToAdmin} variant="contained" color="secondary" disabled={!groupeSecuriteId || groupeSecuriteId === 0}>Ajouter Administrateur</Button>
                                        <Button className={classes.buttonControlGroupesSecurite} onClick={onClickAddToMember} variant="contained" color="secondary" disabled={!groupeSecuriteId || groupeSecuriteId === 0}>Ajouter Affectés</Button>

                                    </Paper>
                                </Grid>



                            </Grid>

                        </Paper>

                        <div className={classes.actionContainer} >

                            <Link to="/administration/groupes">
                                <Button
                                    className={classes.buttonControl}
                                    disabled={!sauvegardable || isPatching}
                                    onClick={onClickSave}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                            </Link>
                            <Link to="/administration/groupes">
                                <Button className={classes.buttonControl} color="primary" >
                                    Annuler
                                </Button>
                            </Link>
                        </div>

                    </div>
                )}

            </React.Fragment>
        );
    }
}

AdministrationGroupe.propTypes = {
    classes: PropTypes.object.isRequired,
    groupesSecurite: PropTypes.array.isRequired,
    groupeSecuriteId: PropTypes.string,
    actionsNonGeneriques: PropTypes.array,
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,
    onClickDeletePilote: PropTypes.func.isRequired,
    onClickDeleteGroupeSecurite: PropTypes.func.isRequired,
    onClickAddPilote: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeUtilisateur: PropTypes.func.isRequired,
    onChangeGroupeSecurite: PropTypes.func.isRequired,
    onClickAddToAdmin: PropTypes.func.isRequired,
    onClickAddToMember: PropTypes.func.isRequired,
    onDrop: PropTypes.func.isRequired,
    sauvegardable: PropTypes.bool.isRequired,
    addPiloteEnable: PropTypes.bool,
    isPatching: PropTypes.bool.isRequired,
    selectedGroupe: PropTypes.object
};

export default withStyles(styles)(AdministrationGroupe);